/* SpecsAtHome cart API integration.
 * Keeps Shopify's legacy Ajax Cart transport, but centralises rendering/events.
 * The drawer itself is controlled only by snippets/mini-cart-drawer.liquid.
 */
(function (window, document, $) {
  'use strict';

  if (!window.Shopify || !$) return;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function dispatch(name, detail) {
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (error) {}
  }

  function money(cents) {
    try {
      return Shopify.formatMoney(cents || 0, Shopify.money_format || '');
    } catch (error) {
      return '';
    }
  }

  function imageUrl(item) {
    if (item && item.featured_image && item.featured_image.url) return item.featured_image.url;
    return item && item.image ? item.image : '';
  }

  function visibleProperties(item) {
    var html = '';
    var properties = item && item.properties ? item.properties : {};
    Object.keys(properties).forEach(function (name) {
      var value = properties[name];
      if (!value || name.charAt(0) === '_') return;
      html += '<div class="sah-mini-property"><span>' + escapeHtml(name) + ':</span><span>' + escapeHtml(value) + '</span></div>';
    });
    return html;
  }

  Shopify.onItemAdded = function () {
    Shopify.getCart(function (cart) {
      Shopify.cartUpdateInfo(cart, '.cart-item-loop');
      dispatch('sah:cart:updated', { cart: cart });
      dispatch('sah:cart:open', { cart: cart });
    });
  };

  Shopify.onCartUpdate = function (cart) {
    Shopify.cartUpdateInfo(cart, '.cart-item-loop');
    dispatch('sah:cart:updated', { cart: cart });
  };

  Shopify.cartUpdateInfo = function (cart, cartCellId) {
    var $cartCell = typeof cartCellId === 'string' ? $(cartCellId) : $();
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    if ($cartCell.length) {
      $cartCell.empty();

      items.slice(0, 20).forEach(function (item) {
        var img = imageUrl(item);
        var title = item.product_title || item.title || '';
        var lineTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="sah-mini-variant">' + escapeHtml(item.variant_title) + '</div>'
          : '';
        var imageMarkup = img
          ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml((item.featured_image && item.featured_image.alt) || title) + '" width="100" height="100" class="img-fluid" loading="lazy" decoding="async">'
          : '';

        var html = ''
          + '<li class="cart-item" data-line-key="' + escapeHtml(item.key) + '">'
          +   '<div class="cart-image"><a href="' + escapeHtml(item.url) + '">' + imageMarkup + '</a></div>'
          +   '<div class="cart-title">'
          +     '<a href="' + escapeHtml(item.url) + '" title="' + escapeHtml(title) + '">' + escapeHtml(title.substring(0, 70)) + '</a>'
          +     lineTitle
          +     '<div class="cart-pro-info">'
          +       visibleProperties(item)
          +       '<div class="cart-qty-price"><span>' + item.quantity + '</span><span> × </span><span class="price-box"><span class="new-price">' + money(item.final_price != null ? item.final_price : item.price) + '</span></span></div>'
          +       '<div class="product-quantity-action">'
          +         '<div class="sah-mini-qty" role="group" aria-label="Quantity for ' + escapeHtml(title) + '">'
          +           '<button type="button" class="sah-mini-qty__btn" data-sah-cart-change data-key="' + escapeHtml(item.key) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">−</button>'
          +           '<span class="sah-mini-qty__value" aria-live="polite">' + item.quantity + '</span>'
          +           '<button type="button" class="sah-mini-qty__btn" data-sah-cart-change data-key="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>'
          +         '</div>'
          +         '<div class="delete-item-cart"><button type="button" class="remove_from_cart" data-sah-cart-change data-key="' + escapeHtml(item.key) + '" data-quantity="0" aria-label="Remove ' + escapeHtml(title) + '"><i class="feather-trash-2" aria-hidden="true"></i></button></div>'
          +       '</div>'
          +     '</div>'
          +   '</div>'
          + '</li>';

        $cartCell.append(html);
      });
    }

    var hasItems = items.length > 0;
    $('.cart-item-loop, .cart-item-title, .subtotal-title-area').toggle(hasItems);
    $('.cart-empty-title').toggle(!hasItems);
    $('.subtotal-price').html(money(cart ? cart.total_price : 0));
    $('.bigcounter').html(cart ? cart.item_count : 0);

    /* Header badge uses both legacy .bigcounter and newer data-cart-count hooks. */
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      var count = cart ? cart.item_count : 0;
      node.textContent = count;
      node.hidden = count <= 0;
      if (count > 0) node.style.display = '';
      else node.style.display = 'none';
    });

    try {
      if (window.feather && typeof window.feather.replace === 'function') window.feather.replace();
    } catch (error) {}
  };
})(window, document, window.jQuery);

function changeHtmlValue(cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
}
